import { render, staticRenderFns } from "./serverRoleOnlineTime.vue?vue&type=template&id=d38f9094&"
import script from "./serverRoleOnlineTime.vue?vue&type=script&lang=js&"
export * from "./serverRoleOnlineTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d38f9094')) {
      api.createRecord('d38f9094', component.options)
    } else {
      api.reload('d38f9094', component.options)
    }
    module.hot.accept("./serverRoleOnlineTime.vue?vue&type=template&id=d38f9094&", function () {
      api.rerender('d38f9094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverRoleOnlineTime.vue"
export default component.exports